import styled from 'styled-components'

export default styled.input`
  & {
    background: none;
    -webkit-appearance: none;
    width: 160px;
    margin: 11.5px 0;
  }
  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #ffb000;
    border-radius: 1px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -11.5px;
  }
  &:focus::-webkit-slider-runnable-track {
    background: #ffb205;
  }
  &::-moz-range-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #ffb000;
    border-radius: 1px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-moz-range-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
  }
  &::-ms-track {
    width: 160px;
    height: 3px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: #faac00;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-fill-upper {
    background: #ffb000;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 26px;
    width: 26px;
    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
    height: 3px;
  }
  &:focus::-ms-fill-lower {
    background: #ffb000;
  }
  &:focus::-ms-fill-upper {
    background: #ffb205;
  }
`
